module.exports = __webpack_public_path__ + "img/weather56.e0554cf5.png";